export const msalConfig = {
  auth: {
    clientId: "836245db-b528-48bd-9fe9-1005fecaaade",
    authority: "https://login.microsoftonline.com/7621b466-29e9-4bad-b8af-bf4977dfba1a",
    //redirectUri: "https://test-deploy.azurewebsites.net/HDMI/quote_tool/index.html",
    //redirectUri: "http://localhost/gf_work/hdmi-qt/build/index.html",
    redirectUri: "http://localhost:3000",
  },
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  }
};

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
 scopes: ["User.Read"]
};

export const logoutRequest = {
  postLogoutRedirectUri: "http://localhost:3000"
};

// Add the endpoints here for Microsoft Graph API services you'd like to use.
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};